// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"603dead8","772":"da9a29be"}[chunkId] + ".chunk.js";
};